import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { BarGraphItem } from './bar-graph-item';

/**
 *
 * STATUS OK
 */
@customElement('d-bar-graph')
export class DBarGraph extends LitElement {
  static readonly styles = css`
    :host {
      display: block;
    }
    .bar {
      display: flex;
      height: 8px;
      margin-right: 1px;
      border-radius: 4px;
      background-color: silver;
      overflow: hidden;
    }
    :host([divider]) .bar > div:not(:last-child) {
      border-right: 1px solid white;
    }
    .legends {
      display: flex;
      flex-wrap: wrap;
      margin-top: 12px;
    }
    .legend {
      display: flex;
      align-items: center;
      height: 16px;
      margin-bottom: 8px;
      font-family: var(--mainSans);
    }
    .legend > div:first-child {
      width: 10px;
      height: 10px;
      margin-right: 8px;
      border-radius: 50%;
    }
    .legend > div:last-child {
      margin-right: 12px;
      font-size: 13px;
    }
  `;
  @property({ type: Array })
  items: BarGraphItem[] = [];

  private get totalCount(): number {
    let count = 0;
    this.items.forEach((item) => {
      count += item.count;
    });
    return count;
  }

  render() {
    return html`
      <div class="bar">
        ${this.items.map(
          (item) => html` <div style="width: ${this.percent(item.count)}%; background: ${item.color}"></div> `,
        )}
      </div>
      <div class="legends">
        ${this.items.map(
          (item) => html`
            ${item.label
              ? html`
                  <div class="legend">
                    <div style="background: ${item.color}"></div>
                    <div>${item.label}</div>
                  </div>
                `
              : nothing}
          `,
        )}
      </div>
    `;
  }

  private percent(count: number): number {
    return (count / this.totalCount) * 100;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-bar-graph': DBarGraph;
  }
}
